import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { GoalCategoriesFormValues } from "src/models/GoalCategories.model";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";

type Props = {
  formikProps: FormikProps<GoalCategoriesFormValues>;
  onClose: () => void;
  formType: "Add" | "Edit";
  setSaveNextChecked?: any;
  saveNextChecked?: any;
};

const GoalCategoriesForm = ({
  formikProps,
  onClose,
  formType,
  saveNextChecked,
  setSaveNextChecked,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex flex-col gap-6 p-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-medium">
          {formType === "Add" ? "Add Goal Category" : "Update Goal Category"}
        </div>
        <button type="button" className="p-2 rounded hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            required
            name="categoryName"
            value={values?.categoryName}
            onChange={(e) => {
              setFieldValue("categoryName", e.target.value);
            }}
            label="Category Name"
            onBlur={handleBlur}
            placeholder="Category Name"
          />
        </div>
      </div>
      {formType === "Add" && (
        <div>
          <ATMCheckbox
            label="Save and Next"
            checked={saveNextChecked}
            inputClasses="h-[15px]"
            // labelClasses="text-sm select-none"
            onChange={(checked) => {
              setSaveNextChecked(checked);
            }}
          />
        </div>
      )}
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default GoalCategoriesForm;
